<template>
    <div class="edu_pages">
      <div class="edu_pages_content_box">
        <div class="edu_page_title_box">
          <div class="title_box">
            <div class="color_lump_box"></div>
            <span>护学岗记录</span>
            <!-- {{ make123 }} -->
          </div>
          <div class="edu_operation_box">
            <el-select
              class="select"
              size="mini"
              style="width:200px;margin-left:5px"
              v-model="searchData.status"
            >
              <el-option
                v-for="(item, index) in stateList"
                :key="index"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <div
              class="search_icon_box button-box"
              @click="getList()"
            >
              <div></div>
              <span>搜索</span>
            </div>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="exportList">导出</el-button>
          </div>
        </div>
        <div class="edu_pages_content_body_box">
          <div class="edu_table_box">
            <el-table
              :data="resData.list"
              height="100%"
              :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
              class="table_box"
            >
              <el-table-column label="序号" align="center" width="60">
                <template slot-scope="scope">
                  {{
                    searchData.pageSize * (searchData.pageNum - 1) +
                      scope.$index +
                      1
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="schoolName" label="学校名称" align="center" width="100"></el-table-column>
              <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
              <el-table-column prop="pt" label="身份" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.pt==1?'警察':'老师' }}</span>
                    <!-- <el-button :type="scope.row.status ? 'success' : 'warning'" plain size="mini">{{ scope.row.status ? '正常' : '禁用' }}</el-button> -->
                </template>
              </el-table-column>
              <el-table-column prop="picture" label="上岗图片" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="fileUrl + scope.row.picture"
                    :preview-src-list="[fileUrl + scope.row.picture]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="startTime" label="上岗时间" align="center" width="160">
                <template v-slot="scope">
                    {{ $Common.dateFormatDateTwo(scope.row.startTime) }}
                </template>
              </el-table-column>

              <el-table-column prop="endTime" label="下岗时间" align="center" width="150">
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ $Common.dateFormatDateTwo(scope.row.endTime) }}
                    </span>
                </template>
              </el-table-column>
              <el-table-column prop="upLocation" label="上岗地点" align="center" width="120" show-overflow-tooltip></el-table-column>
              
              <el-table-column prop="downLocation" label="下岗地点" align="center" width="120" show-overflow-tooltip>
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ scope.row.downLocation }}
                    </span>
                </template>
              </el-table-column> -->
             
              <el-table-column prop="startTime" label="上下岗时间" align="center" width="200">
                <template v-slot="scope">
                    上岗：<span>{{ $Common.dateFormatDateTwo(scope.row.startTime) }}</span>
                    <br />
                    下岗：<span  v-if="scope.row.status==1">护学中</span>
                    <span v-else>{{ $Common.dateFormatDateTwo(scope.row.endTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="upLocation" label="上下岗地点" align="center" width="360">
                <template v-slot="scope">
                  <span>{{ scope.row.upLocation }}</span>
                  <br>
                  <span  v-if="scope.row.status==1">
                    护学中
                  </span>
                  <span v-else>
                    {{ scope.row.downLocation }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="content" label="护学人数" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="remarks" label="突发事件记录" align="center" show-overflow-tooltip>
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ scope.row.remarks }}
                    </span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="护岗状态" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status==1 ? 'success' : 'info'">{{ scope.row.status==1 ? '上岗中' : '已下岗' }}</el-tag>
                </template>
              </el-table-column>
              
              
              <!-- <el-table-column prop="content" width="140" label="护岗内容" align="center" show-overflow-tooltip></el-table-column> -->
            </el-table>

              
          </div>
          <div class="edu_pagination_box">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="resData.pageNum"
              :page-size="resData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="resData.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
        <el-dialog :visible.sync="editShow" :title="dialogType=='add' ? '新增' : '编辑'" width="600px">
            <el-form :data="column_row" label-width="120px" size="mini">
                <el-form-item label="用户名称" prop="userName">
                    <el-input v-model="column_row.userName"/>
                </el-form-item>
                <el-form-item label="手机号" prop="userPhone">
                    <el-input v-model="column_row.userPhone"/>
                </el-form-item>
                <el-form-item label="用户密码" prop="userPwd">
                    <el-input type="password" v-model="column_row.userPwd"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editShow = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="submit_edit" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "nursingPost",
    data() {
      return {
        fileUrl: this.$store.state.config.fileUrl,
        eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
        searchData: {
          eduId: "",
          pageNum: 1,
          pageSize: 20,
          status: 0
        //   hiddenDangerStatus: ""
        },
        // 隐患督办数据
        resData: {
          list: [],
          pageNum: 1,
          pageSize: 20,
          pages: 0,
          total: 0
        },
        checkResize: 0,
        hiddenDangerId: 0,
        superviseResize: 0,
        selData: {},
        fileResize: 0,
        editShow:false,
        dialogType:'add',
        column_row:{},
        stateList: [
            { id: 0, label: "全部" },
            { id: 1, label: "已上岗" },
            { id: 2, label: "已下岗" }
        ],
        make123:'123'
      };
    },
    mounted() {
      this.getList();
    //   this.getOrientation()
    },
    methods: {
      handleCurrentChange(val) {
        this.searchData.pageNum = val;
        // console.log(`当前页: ${val}`);
        this.getHiddenDangerData();
      },
      getList(){
        // console.log(eduId, "=========")
        this.searchData.eduId = this.$store.getters.getEduData.eduId;
        this.searchData.pageNum = 1;
        this.getHiddenDangerData();
      },
      // 获取护学列表
      async getHiddenDangerData() {
        console.log(this.searchData,'this.searchData')
        // this.searchData.eduId = this.eduInfo.eduId;
        // this.searchData.educationBureauType = this.eduInfo.eduBuresuType;
        // this.searchData.regionCode = this.eduInfo.regionCode;
        let res = await this.$Http.gethxgRecordsList(this.searchData);
        if (res.code == 200) {
          this.resData = res.data;
        } else if (res.code == 101) {
          this.resData.list = [];
          this.total = 0;
        } else {
          this.$message({
            type: "error",
            message: res.messsage
          });
        }
      },
      //导出
      async exportList(){
        var req = {
          eduId:this.$store.getters.getEduData.eduId
        };
        this.$Common.exportData(req, "exportRecord", "护学记录");


        // let data = {
        //   eduId:this.$store.getters.getEduData.eduId
        // }
        // let res = await this.$Http.exportRecord(data);
        // if (res.status == 200) {
        //   console.log(res)
        //   this.blobToExcel(res.data, "护学记录"+Date.parse(new Date())+".xls")
        //   // window.open(res)
        //   // let a = document.createElement("a");
        //   // // 下载名字
        //   // a.download = '护学记录';
        //   // //url
        //   // a.href = res.data;
        //   //合成函数，执行下载
        //   // a.dispatchEvent(new MouseEvent("click"));
        // }
      },
      blobToExcel(res, name) {
        var blob = new Blob([res], {
          type: 'application/vnd.ms-excel'
          // type: 'application/vnd.ms-excel;charset=utf-8'
        }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, name)
        } else {
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = name // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        }
      },
      // 新增弹框
      add(){
        this.dialogType = 'add';
        this.column_row = {};
        this.editShow = true;
      },
    //   编辑
      edit(row){
        this.dialogType = 'edit';
        this.column_row = Object.assign({},row);
        this.editShow = true;
      },
    //   提交
      async submit_edit(){
        let res = ''
        if(this.dialogType == 'add'){
            this.column_row.eduId = this.$store.getters.getEduData.eduId;
            res = await this.$Http.addEduhxgUser(this.column_row);
        }else{
            res = await this.$Http.editEduhxgUser(this.column_row);
        }
        if (res.code == 200) {
            this.$message({
                type: "success",
                message: res.messsage
            });
            this.getList();
            this.editShow = false;
        }else{
            this.$message({
                type: "error",
                message: res.messsage
            });
        }
      },
      // 删除
       delete_row(row){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.sure_delete(row)
        })
      },
      async sure_delete(row){
        let res = await this.$Http.deleteEduhxgUser(row);
        if (res.code == 200) {
            this.$message.success('删除成功');
            this.getList();
        }
      },
      // 查看隐患详情信息
      getDetail(id) {
        this.hiddenDangerId = id;
        this.checkResize++;
      },
      // 查看下发文件
      getFile(row) {
        this.selData = row;
        this.fileResize++;
      },
      jump() {
        this.$Common.pageJump("/eduHiddenDangerSupervise", 2);
      },
      // 督办
      supervise(row) {
        this.selData = row;
        this.superviseResize++;
      }
    }
  };
  </script>
  <style scoped lang="scss">
  .edu_header_title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 2rem;
    cursor: pointer;
    &.active {
      background-color: rgba(28, 113, 251, 0.3);
      color: #1c71fb;
      border-bottom: 3px solid #1c71fb;
    }
  }
  .edu_pages_content_header {
    .demo-form-inline {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .el-form-item {
      .input,
      .select {
        width: 180px;
      }
      .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .el-table {
    overflow: scroll;
    scrollbar-width: none;
    &:before {
      display: none;
    }
    .button {
      margin-bottom: 10px;
    }
  }
  
  @import "../../../../../public/css/edu_pages.scss"
  </style>
  